/**
 * Public app base URL for candidate-facing links (apply pages, etc.).
 * Prefer REACT_APP_GAPPEO_APP_BASE_URL (mirrors API GAPPEO_APP_BASE_URL).
 * Falls back to current origin so local/demo hosts are not hardcoded.
 */
export function getAppBaseUrl() {
  const fromEnv = (process.env.REACT_APP_GAPPEO_APP_BASE_URL || '').trim().replace(/\/$/, '');
  if (fromEnv) return fromEnv;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return '';
}

/** Template used on job create; API replaces [job_id] (and prefers GAPPEO_APP_BASE_URL). */
export function buildJobApplyUrlTemplate() {
  const base = getAppBaseUrl();
  return base ? `${base}/jobs/[job_id]/apply` : '';
}
